/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description butter helper for message action
 */

import { ButterAction } from '@zcode-ui/web-zumper-global-state'
import { APP_NAME } from '@zcode/env'
import type { MessageData } from '@zcode/state-type'
import { logger } from '../../../../logger'
import type { Dispatch } from '../../../types'

interface BaseHandleButterProps {
  /** in ms */
  duration?: number
  msg: string
  type?:
    | typeof ButterAction.ERROR_COLOR
    | typeof ButterAction.INFO_COLOR
    | typeof ButterAction.SUCCESS_COLOR
    | typeof ButterAction.WARNING_COLOR
}

interface ReportHandleButterProps extends BaseHandleButterProps {
  entity: MessageData
  report: true
}

interface NormalHandleButterProps extends BaseHandleButterProps {
  entity?: never
  report?: false
}

type HandleButterProps = ReportHandleButterProps | NormalHandleButterProps

// set a notification. msg/duration.
export const handleButter =
  ({ entity, msg, duration = 3000, report, type = ButterAction.ERROR_COLOR }: HandleButterProps) =>
  (dispatch: Dispatch) => {
    const message: {
      duration: number
      message: string
      color: typeof type
      isMessageButter: true
      action?: () => void
      actionText?: string
    } = {
      duration,
      message: msg,
      color: type,
      isMessageButter: true,
    }

    if (report) {
      try {
        if (APP_NAME === 'Zumper') {
          message.actionText = 'Please contact support here.'
          message.action = () => {
            window.open('https://help.zumper.com/hc/en-us/requests/new', '_blank')
          }
        } else {
          message.actionText = 'Report'
          message.action = () => {
            let ids = entity.building
              ? `b:${entity.building.buildingId}`
              : `l:${entity.listing?.listingId}`
            ids = report === true ? ids : report
            const subject = encodeURIComponent(`Issue messaging this property: ${ids}`)
            const body = encodeURIComponent(
              `I was unable to message this property: ${ids}\n\n--\n\n` +
                `Thank you for reporting this issue\n\n- ${APP_NAME}`
            )
            const email = 'hello@padmapper.com'
            window.open(`mailto:?to=${email}&subject=${subject}&body=${body}`)
          }
        }
      } catch (err) {
        logger.error('butter: issue messaging', entity.building?.uId, entity.listing?.uId, err)
      }
    }
    dispatch(ButterAction.addNotifyButterBar(message))
  }
